import { useRef } from 'react';
import { useDisclosure } from '@chakra-ui/react';

import { UserProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import AddressForm from 'features/Onboarding/components/AddressForm';
import { AddressFormElement } from 'features/Onboarding/components/AddressForm/AddressForm';
import { AddressSchema } from 'features/Onboarding/components/AddressForm/addressSchema';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import locales from './locales';

interface AddressProps {
  onContinue: (payload: AddressSchema) => void;
  defaultAddress: Pick<
    UserProfile,
    'city' | 'streetAddition' | 'street' | 'zip' | 'country'
  >;
  isSaving: boolean;
}

const Address = asBentoPage<AddressProps>(
  ({ defaultAddress, isSaving, Layout, onContinue, onPrev }) => {
    const addressOverlay = useDisclosure();

    const addressFormRef = useRef<AddressFormElement>(null);

    const handlePrev = () => {
      if (addressFormRef.current?.isEditing) {
        addressFormRef.current?.reset();
        return;
      }
      onPrev();
    };

    return (
      <Layout
        data-testid="personal-address"
        nav={
          <OBNavigation
            isCollapsed={addressOverlay.isOpen ? true : undefined}
            onClose={addressOverlay.isOpen ? addressOverlay.onClose : undefined}
            onPrev={handlePrev}
          />
        }
      >
        <AddressForm
          addressOverlayClose={addressOverlay.onClose}
          initialValues={defaultAddress}
          isOverlayOpen={addressOverlay.isOpen}
          isSending={isSaving}
          locales={{
            continueCta: locales.continueCta,
            streetLabel: locales.streetLabel,
            title: locales.title,
          }}
          onContinue={onContinue}
          onOverlayClose={addressOverlay.onClose}
          onOverlayOpen={addressOverlay.onOpen}
          ref={addressFormRef}
        />
      </Layout>
    );
  },
);

export default Address;
